import { inject, Injectable } from '@angular/core';
import { ApiHelper, ApiService, HttpResponse, HttpStatusEnum } from '@core/api';

@Injectable({ providedIn: 'root' })
export class AbiOrderFileApi {
    private apiService = inject(ApiService);

    downloadAbiOrderFile(fileName: string): Promise<HttpResponse<any>> {
        return new Promise<HttpResponse<any>>(resolve => {
            this.apiService.post(`abi-order-file-import/download-abi-order-file?fileName=${fileName}`).subscribe({
                next: (res: any) => {
                    resolve({
                        isLoading: true,
                        status: HttpStatusEnum.SUCCESS,
                        data: res,
                    });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, err?.error?.message);
                    console.error(err);
                },
            });
        });
    }
}
